module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/app-mob-fd63fea49444e42547852f9c29fb6c02.png";